import { render, staticRenderFns } from "./RevertJob.vue?vue&type=template&id=2bd5afb4&scoped=true"
import script from "./RevertJob.vue?vue&type=script&lang=js"
export * from "./RevertJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5afb4",
  null
  
)

export default component.exports